import {Component, computed, input, model} from '@angular/core';
import {IconsComponent} from '../icons/icons.component';

@Component({
  selector: 'app-accordion',
  standalone: true,
  imports: [
    IconsComponent
  ],
  templateUrl: './accordion.html',
  styleUrl: './accordion.css',
})
export class Accordion {
  label = input.required<string>();
  isOpen = model<boolean>(false);

  labelSlug = computed(() => {
    return this.label()
      .toLowerCase()
      .trim()
      .replace(/[^\w\s-]/g, '')
      .replace(/[\s_-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  });

  headerID = computed(() => `accordion-flush-heading-${this.labelSlug()}`);

  bodyID = computed(() => `accordion-flush-body-${this.labelSlug()}`);

  toggle() {
    this.isOpen.update(open => !open);
  }
}
